$.ajaxSetup({
    headers: { 'X-CSRF-Token': $('meta[name=_token]').attr('content') }
});

$.fancybox.defaults.hash = false;

jQuery.ui.autocomplete.prototype._resizeMenu = function() {
    var ul = this.menu.element;
    ul.outerWidth(this.element.outerWidth() + 14);
    ul.left('-7px');
}

$('[data-fancybox]').fancybox({
    image: {
        protect: true
    }
});

$('body').on('click', '[data-ga-track]', function() {
    if (typeof ga !== 'undefined') {
        ga('send', 'pageview', $(this).data('ga-track'));
    }
});

var gotoExternal = function(url) {

    if (typeof ga !== 'undefined') {
        ga('send', 'event', 'LinkWychodzacy', 'Klikniecie', url);
    }

    setTimeout(function() {
        document.location = url;
    }, 3000)
}

$.widget("custom.catcomplete", $.ui.autocomplete, {
    _create: function() {
        this._super();
        this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
    },
    _renderMenu: function(ul, items) {
        var that = this,
            currentCategory = "";
        $.each(items, function(index, item) {
            var li;
            if (item.category != currentCategory) {
                ul.append("<li class='ui-autocomplete-category'>" + item.category + "</li>");
                currentCategory = item.category;
            }
            li = that._renderItemData(ul, item);
            if (item.category) {
                li.attr("aria-label", item.category + " : " + item.label);
            }
        });
    }
});
function openformpopup(){
    $(".overlay2").fadeIn('300', function () {
        $(".autorize-popup.grupowezapytanie-popup").animate({'margin-top': 0 + "%",}, 300);
    });
}
$(document).ready(function() {
    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });
    $('.seobox-toggle').on("click", function(e){
        e.preventDefault()
        $(this).closest(".seo-box").toggleClass("open");
        $(this).closest(".seo-box").find(".seo-box-content").slideToggle()
    })
    if ($('#cookies-bar').length > 0) {
        $('#cookies-close-button').click(function() {
            $.ajax({
                url: $(this).attr('href'),
                type: 'post',
                success: function(response) {
                    if (response == 'ok') {
                        $('#cookies-bar').remove();
                    }
                }
            });
            return false;
        });
    }

    $('#halls-no').change(function() {
        $('.hall-items .hall-item').hide();
        var roomsno = $(this).val();
        $('.hall-items .hall-item').slice(0, roomsno).show();
    });

    $('#halls-no').change();

    $('.open-form-popup').on('click tap', function(event) {
        event.preventDefault();

        $(".overlay").fadeIn('300', function() {
            $(".autorize-popup.grupowezapytanie-popup").animate({ 'margin-top': 0 + "%", }, 300);
        });

    });


    $('.overlay, .autorize-popup.grupowezapytanie-popup .close').on('click tap', function(event) {
        event.preventDefault();
        $(".autorize-popup.grupowezapytanie-popup").animate({ 'margin-top': -800 + "%", }, 300,
            function() {
                $(".overlay, .overlay2").fadeOut('300')
            }
        );
    });

    $('.open-form-popup-zapytanie').on('click tap', function (event) {
        event.preventDefault();

        $(".overlay").fadeIn('300', function () {
            $(".autorize-popup.zapytanie").animate({'margin-top': 0 + "%",}, 300);
        });

        $("html, body").animate({scrollTop: 0}, "slow");

    });

    $('.overlay, .autorize-popup.zapytanie .close').on('click tap', function(event) {
        event.preventDefault();
        $(".autorize-popup.zapytanie").animate({ 'margin-top': -800 + "%", }, 300,
            function() {
                $(".overlay, .overlay2").fadeOut('300')
            }
        );
    });

    $("#newsletterForm").validate({
        submitHandler: function(form) {
            form.submit();
        }
    });

    $(".read-more-button").click(function() {
        $('#' + $(this).data('rel')).removeClass('visuallyhidden');
        return false;
    });

    $('#calendarDateSelect').change(function() {
        window.location.href = $(this).val();
    });

    $('.more-overlay .fa').click(function() {
        $(this).parent().addClass('visuallyhidden');
        return false;
    });

    $('.print-button').click(function() {
        window.open(
            $(this).attr('href'),
            "Drukuj kartę obiektu",
            "status=1,scrollbars=1,width=520,height=500, directories=no,  menubar=no, resizable=no, top=100, left=300");

        return false;
    });

    $('#questionForm').validate({
        errorClass: "error2",
        errorElement: "div",
        errorPlacement: function (error, element) {
            if (element.attr("type") == "checkbox") {
                if ($(element).closest(".acceptance").length) {
                    $(element).closest(".acceptance").append(error);
                } else if ($(element).closest(".form-wrap").length) {
                    $(element).closest(".form-wrap").append(error);
                }

            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {

            swal({
                text: "Trwa wysyłanie.",
                type: "info",
                showConfirmButton: false,
                confirmButtonColor: '#97762c'
            });

            $('#questionForm').ajaxSubmit({
                beforeSubmit: function() {
                    $('#autorize-bottom button').attr('disabled', 'disabled');
                    $('#autorize-bottom button').css('opacity', '0.5');
                },
                success: function(response) {
                    var response = jQuery.parseJSON(response);

                    if (response.status == 'ok') {
                        $('.buttons-row .cat-list-btn').trigger('click tap');
                        
                        swal({
                            title: "Dziękujemy!",
                            text: "Zapytania zostały wysłane.",
                            type: "success",
                            confirmButtonColor: '#97762c'
                        });

                        $('#questionForm .close').click();
                        if (response.typ=='group'){
                            gtag('event', 'Zapytanie grupowe', {
                                'event_category': 'Formularze'
                                });
                        }
                        if (response.typ=='object'){
                            gtag('event', 'Zapytanie na stronie obiektu', {
                                'event_category': 'Formularze'
                                });
                        }
                    } else {
                        $('#captcha').attr('src', response.view);
                        swal({
                            title: "Uwaga!",
                            text: "Prosimy o zaznaczenie weryfikacji Google Captcha. Dziękujemy.",
                            type: "warning",
                            confirmButtonColor: '#97762c'
                        });
                        $('#autorize-bottom button').removeAttr('disabled');
                        $('#autorize-bottom button').css('opacity', '1');
                    }
                }
            });

            return false;
        }
    });

    $('#questionFormSmall').validate({
        errorClass: "error2",
        errorElement: "div",
        errorPlacement: function (error, element) {
            if (element.attr("type") == "checkbox") {
                if ($(element).closest(".acceptance").length) {
                    $(element).closest(".acceptance").append(error);
                } else if ($(element).closest(".form-wrap").length) {
                    $(element).closest(".form-wrap").append(error);
                }

            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {

            swal({
                text: "Trwa wysyłanie.",
                type: "info",
                showConfirmButton: false,
                confirmButtonColor: '#97762c'
            });

            $('#questionFormSmall').ajaxSubmit({
                beforeSubmit: function() {
                    $('#autorize-bottom button').attr('disabled', 'disabled');
                    $('#autorize-bottom button').css('opacity', '0.5');
                },
                success: function(response) {
                    var response = jQuery.parseJSON(response);

                    if (response.status == 'ok') {
                        $('.buttons-row .cat-list-btn').trigger('click tap');
                        
                        swal({
                            title: "Dziękujemy!",
                            text: "Zapytania zostały wysłane.",
                            type: "success",
                            confirmButtonColor: '#97762c'
                        });

                        $('#questionFormSmall .close').click();
                        if (response.typ=='group'){
                            gtag('event', 'Zapytanie grupowe', {
                                'event_category': 'Formularze'
                                });
                        }
                        if (response.typ=='object'){
                            gtag('event', 'Zapytanie na stronie obiektu', {
                                'event_category': 'Formularze'
                                });
                        }
                    } else {
                        $('#captcha').attr('src', response.view);
                        swal({
                            title: "Uwaga!",
                            text: "Prosimy o zaznaczenie weryfikacji Google Captcha. Dziękujemy.",
                            type: "warning",
                            confirmButtonColor: '#97762c'
                        });
                        $('#autorize-bottom button').removeAttr('disabled');
                        $('#autorize-bottom button').css('opacity', '1');
                    }
                }
            });

            return false;
        }
    });

    $('#reasons-slider').bxSlider({
        infiniteLoop: true,
        speed: 500,
        mode: 'fade',
        minSlides: 1,
        maxSlides: 1,
        moveSlides: 1,
        auto: true,
        slideMargin: 0
    });

    $('#gallery').bxSlider({
        infiniteLoop: true,
        speed: 500,
        slideWidth: 108,
        minSlides: 1,
        maxSlides: 6,
        moveSlides: 1,
        auto: false,
        slideMargin: 7
    });

    $('#gallery2, #gallery3').bxSlider({
        infiniteLoop: true,
        speed: 500,
        slideWidth: 95,
        minSlides: 1,
        maxSlides: 3,
        moveSlides: 1,
        auto: false,
        slideMargin: 7
    });

    $("#partners-slider").owlCarousel({
        items: 6,
        autoPlay: 3000,
        navigation: true,
        navigationText: ["<span></span>", "<span></span>"],
        itemsDesktop: [1120, 6], //5 items between 1000px and 901px
        itemsDesktopSmall: [900, 3], // betweem 900px and 601px
        itemsTablet: [620, 2], //2 items between 600 and 479
        itemsMobile: [479, 1], //1 item between 479 and 0
        stopOnHover: true,
        autoHeight: true
    });

    $("#partners-slider2").owlCarousel({
        items: 6,
        autoPlay: 3000,
        navigation: true,
        navigationText: ["<span></span>", "<span></span>"],
        itemsDesktop: [1120, 6], //5 items between 1000px and 901px
        itemsDesktopSmall: [900, 3], // betweem 900px and 601px
        itemsTablet: [620, 2], //2 items between 600 and 479
        itemsMobile: [479, 1], //1 item between 479 and 0
        stopOnHover: true
    });

    $("#contactForm").validate({
        errorPlacement: function (error, element) {
            if (element.attr("type") == "checkbox") {
                if ($(element).closest(".acceptance").length) {
                    $(element).closest(".acceptance").append(error);
                } else if ($(element).closest(".form-wrap").length) {
                    $(element).closest(".form-wrap").append(error);
                }

            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            form.submit();
        }
    });

    $("#commentForm").validate({
        submitHandler: function(form) {
            form.submit();
        }
    });

    $('.p-item-slider').each(function(){
        var slider = $(this).bxSlider({
            infiniteLoop: true,
            speed: 600,
            minSlides: 1,
            maxSlides: 1,
            moveSlides: 1,
            auto: false,
            slideMargin: 0
        });
        $(window).load(function(){
            if ($(window).width() > 767) {
                slider.reloadSlider();
            } else {
                setTimeout(function(){
                    slider.reloadSlider();
                }, 300)
            }
            
            if (lazyLoadInstance) {
                lazyLoadInstance.update();
            }
        })
    })


    $("#tags").catcomplete({
        appendTo: "#autocompleteBox",
        source: "/main-autocomplete",
        select: function(event, ui) {
            $(this).val(ui.item ? ui.item : " ");
        },
        change: function(event, ui) {
            if (!ui.item) {
                this.value = '';
            }
        }
    });

    $("#companyTags").catcomplete({
        appendTo: "#autocompleteCompanyBox",
        source: "/company-autocomplete",
        select: function(event, ui) {
            $(this).val(ui.item ? ui.item : " ");
        },
        change: function(event, ui) {
            if (!ui.item) {
                this.value = '';
            }
        }
    });

    $("#quickSearch").autocomplete({
        appendTo: "#autocompleteObjectsBox",
        source: "/objects-autocomplete",
        select: function(event, ui) {
            $(this).val(ui.item ? ui.item : " ");
        },
        change: function(event, ui) {
            if (!ui.item) {
                this.value = '';
            }
        }
    });

    $('.same-height').matchHeight({
        // target: $('.sidebar')
    });
});

/*

var app = {};

//======================================================= HOME
app.home = {};


//===================wyszukiwarka home page
app.home.searchBox = {

    tabsInit: function () {

        $('.search-double_tabs a').click(function () {

            if (!$(this).parent().hasClass('selected')) {

                $('.search-double_tabs li').removeClass('selected');
                $(this).parent().addClass('selected')

                var contId = $(this).data('href');

                $('.search-double .tab_cont').hide();
                $('#' + contId).show();

            }

            return false;
        });

    }

    //selekty zainicjowac
    //checkbox do podpiecia

};

//=================== Stream newsów homepage

app.home.news = {

    tabsInit: function () {

        $('.stream-section .stream_tabs a').click(function () {

            if (!$(this).parent().hasClass('selected')) {

                $('.stream_tabs li').removeClass('selected');
                $(this).parent().addClass('selected')

                var contId = $(this).data('href');

                $('.stream-section .tab_cont').hide();
                $('#' + contId).show();

            }

            return false;
        });

    }


};

//=================== mapka województw homepage

app.home.map = {

    init: function () {

        $('#cssMapTrigger').click(function () {

            $('#cssMapTrigger').css('display', 'none');
            $('#map-poland ul').css('display', '');

            $('#map-poland').cssMap({
                'size': 240,
                'onClick': function (e) {

                    var provinceSlug = $(e).data('href');

                    $.magnificPopup.open({
                        items: {
                            src: '#objects-map-popup',
                            type: 'inline'
                        },
                        midClick: true,
                        callbacks: {
                            open: function () {
                                $('#objects-map').css('height', $(window).height() - 120);
                                $.get('/map/' + provinceSlug, function (response) {
                                    app.popups.map.init(response);
                                }, 'json');
                            },
                            close: function () {
                                $('#objects-map').html('');
                            }

                        }
                    });
                    return false;
                }
            });

            $('#map-poland-all').click(function (e) {

                e.preventDefault();

                $.magnificPopup.open({
                    items: {
                        src: '#objects-map-popup',
                        type: 'inline'
                    },
                    midClick: true,
                    callbacks: {
                        open: function () {
                            $('#objects-map').css('height', $(window).height() - 120);
                            $.get('/map/all', function (response) {
                                app.popups.map.init(response);
                            }, 'json');
                        },
                        close: function () {
                            $('#objects-map').html('');
                        }

                    }
                });
                return false;
            });
        });
    }
}

//======================================================= FOOTER
//stopka karuzela
app.footer = {

    Carouselinit: function () {

        $("#main-footer-slider").owlCarousel({
            autoPlay: 3000, //Set AutoPlay to 3 seconds
            items: 7,
            itemsDesktop: [1140, 6],
            itemsDesktopSmall: [979, 5],
            itemsTablet: [768, 4],
            itemsTabletSmall: [640, 3],
            itemsMobile: [400, 2],
            pagination: false,
            navigation: true,
            lazyLoad: true
        });

    }
}


//======================================================= OBJECT
app.object = {};

app.object.slider = {

    init: function () {
        this.sliderLargeinit();
        this.sliderSmallInit();
    },
    sliderLargeinit: function () {

        $(".slider-section .thumbnail-list").owlCarousel({
            items: 4,
            navigation: true,
            itemsDesktopSmall: [979, 4],
            itemsTablet: [768, 4],
            itemsMobile: [479, 4]

        });

        $(".slider-section .thumbnail-list div.thumbnail").not('active').click(function () {

            var picid = $(this).data('rel');

            if (picid == 'video') {

                $('.view-chooser-box .video-ico').click();
                return false;
            }

            $(".slider-section .thumbnail-list div.thumbnail").removeClass('active');
            $(this).addClass('active');



            $('.slider.type1 .slider-img img').hide();

            $('#' + picid).show();

            return false

        });

        if ($(window).width() > 480) {
            //gallery zoom init
            $("a[rel^='prettyPhoto']").prettyPhoto({

                show_title: false,
                social_tools: '',
                horizontal_padding: 0

            });
        } else {

            $(".slider-img > a").click(function () {
                return false;
            })

        }

    },
    sliderSmallInit: function () {

        $('.slider.type2 .thumbnail-list div.thumbnail').not('active').click(function () {

            $(this).parents('.slider.type2').find('.thumbnail-list div.thumbnail').removeClass('active');
            $(this).addClass('active');

            var picid = $(this).data('rel');

            $(this).parents('.slider.type2').find('.slider-img a').hide();

            $('#' + picid).show();


            return false

        });


    }

}
app.object.verticalCarousel = {

    init: function () {

        if ($('.vertical-slider .slide').size() > 5) {
            $('.vertical-slider').bxSlider({
                mode: 'vertical',
                slideWidth: 300,
                minSlides: 5,
                slideMargin: 22,
                pager: false,
                infiniteLoop: false,
                hideControlOnEnd: true,
                moveSlides: 1

            });

        }


    }

}

app.object.horizontalCarousel = {

    init: function () {

        $(".horizontal-slider").owlCarousel({

            autoPlay: false, //Set AutoPlay to 3 seconds

            items: 3,
            itemsDesktop: [1140, 3],
            itemsDesktopSmall: [979, 3],
            itemsTablet: [718, 2],
            itemsTabletSmall: [640, 2],
            itemsMobile: [450, 1],
            pagination: false,
            navigation: true

        });


    }

}

//mapka na stronie pojedynczego obiektu
app.object.locationMap = {

    init: function () {

        var mapCanvas = document.getElementById('location-map');
        var mapOptions = {
            center: new google.maps.LatLng($('#location-map').data('lat'), $('#location-map').data('lng')),
            zoom: $('#location-map').data('zoom'),
            mapTypeId: google.maps.MapTypeId.ROADMAP
        }
        var locmap = new google.maps.Map(mapCanvas, mapOptions);

        //przykladowy marker lokalizacji
        var image = '/img/ico/map-marker-blue.png';
        var myLatLng = new google.maps.LatLng($('#location-map').data('lat'), $('#location-map').data('lng'));

        var marker = new google.maps.Marker({
            position: myLatLng,
            map: locmap,
            icon: image
        });

        var contentString = '<div class="map-infowindow">' +
            '<img class="f_left" src="' + $('#location-map').data('image-url') + '" width="120" alt="' + $('#location-map').data('name') + '">' +
            '<div class="bodyContent">' +
            '<span class="title">' + $('#location-map').data('name') + '</span>' +
            '<p>Liczba miejsc na konferencje: <span>' + $('#location-map').data('biggest-hall-capacity') + '</span></p>' +
            '<p>Liczba miejsc noclegowych: <span>' + $('#location-map').data('beds-amount') + '</span></p>' +
            '</div>' +
            '</div>';

        var infowindow = new google.maps.InfoWindow();
        //przypina tooltip do markera
        google.maps.event.addListener(marker, 'click', function () {
            infowindow.setContent(contentString);
            infowindow.open(locmap, marker);
            marker.setIcon('/img/ico/map-marker-dark_blue.png')
        });
    }

}

//formularz zaytania o obiekt
app.object.questionForm = {

    init: function () {
        //init selectów
        $('.custom').SumoSelect();
        this.datesLogic();
        this.roomsLogic();

        $('#questionForm').validate({
            submitHandler: function (form) {
                $('#questionForm').ajaxSubmit({
                    beforeSubmit: function () {
                        $('#questionForm .flat-button').attr('disabled', 'disabled');
                        $('#questionForm .flat-button').css('opacity', '0.5');
                    },
                    success: function (response) {

                        var response = jQuery.parseJSON(response);

                        if (response.status == 'ok') {

                            if (response.type == 'full_presentation') {
                                $('#question-form-after-popup').replaceWith(response.view);
                                $.magnificPopup.close();
                                $.magnificPopup.open({
                                    items: {
                                        src: '#question-form-after-popup'
                                    },
                                    type: 'inline'
                                });

                                $('#question-form-after-popup .object-box').matchHeight({
                                    byRow: true,
                                    property: 'height',
                                    target: null,
                                    remove: false
                                });

                                $('#question-form-after-popup .object-box h5').matchHeight({
                                    byRow: true,
                                    property: 'height',
                                    target: null,
                                    remove: false
                                });

                                $('#questionNearestForm').ajaxForm({
                                    beforeSubmit: function () {
                                        if ($("#questionNearestForm input[name='objects[]']:checked").length == 0) {
                                            swal("Uwaga!", "Musisz zaznaczyć przynajmniej jeden obiekt.", "warning")
                                            return false;
                                        } else {
                                            $('#questionNearestForm .flat-button').attr('disabled', 'disabled');
                                            $('#questionNearestForm .flat-button').css('opacity', '0.5');
                                        }
                                    },
                                    success: function () {
                                        $.magnificPopup.close();
                                        swal("Dziękujemy!", "Zapytania zostały wysłane.", "success")
                                    }
                                });
                            } else {
                                $.magnificPopup.close();
                                swal("Dziękujemy!", "Zapytanie zostało wysłane.", "success")
                            }
                        } else {
                            $('#captcha').attr('src', response.view);
                            swal("Uwaga!", "Prosimy o zaznaczenie weryfikacji Google Captcha. Dziękujemy.", "warning");
                            $('#questionForm .flat-button').removeAttr('disabled');
                            $('#questionForm .flat-button').css('opacity', '1');
                        }
                    }
                });
            }
        })
    },
    datesLogic: function () {

        //init datepickerów - jesli pola z datami sa wybrane pojawiaja sie pola z godzinami
        $('input.datepicker').Zebra_DatePicker({
            format: 'd-m-Y',
            default_position: 'below',
            months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
            show_select_today: false,
            onSelect: function (date1, date2, date3, elem) {

                if ($('#date_from').val() == $('#date_to').val()) {
                    $('.question-form-popup .hours').css('visibility', 'visible');
                } else {
                    $('.question-form-popup .hours').css('visibility', 'hidden');
                }
            },
            onClear: function () {
                $('.question-form-popup .hours').css('visibility', 'hidden');
            }
        });

    },
    roomsLogic: function () {

        //zaleznie od ilosci sal wyswietla si odpowiednia ilosc pol
        $('#rooms-no').change(function () {

            $('#question-form-popup .room-item').hide();
            var roomsno = $(this).val();

            $($('#question-form-popup .room-item').getRange(0, roomsno - 2)).show();


        });


    }

}
//formularz comentowania
app.object.commmentForm = {


    init: function () {


        $('#show-add-comment').click(function () {

            $('.add-comment').show();
            $(this).hide();


            return false;
        });

        this.formInit();

    },
    formInit: function () {


        this.starVotes();


    },
    starVotes: function () {

        //star voting
        $('#add-comment-form .stars .star-select').mouseenter(function () {

            $('#add-comment-form .stars .star-select').removeClass('active');

            $(this).prevAll().addClass('active');
            $(this).addClass('active');

        });
        $('#add-comment-form .stars').mouseout(function () {

            $('#add-comment-form .stars .star-select').removeClass('active');

        });

        $('#add-comment-form .stars .star-select').click(function () {

            $('#add-comment-form .stars .star-select').removeClass('selected');

            $(this).prevAll().addClass('selected');
            $(this).addClass('selected');


            $('#comment-vote').val($(this).data('href')); //przekuje wartosc hrefa do inputa

            return false;

        });

    }

}

app.object.video = {

    init: function () {

        $('.view-chooser-box span').click(function () {


            if (!$(this).hasClass('active')) {

                $('.view-chooser-box span').removeClass('active');

                $(this).addClass('active');

                $('.yt, .slider.type1').hide();
                $($(this).data('href')).show();

            }

            return false
        });


    }


}

var selectedLat = null;
var selectedLng = null;
var directionMap = null;
var directionsService = new google.maps.DirectionsService();
var trasa;

//======================================================= POP UPS
app.popups = {};
app.popups.map = {};

app.popups.map = {

    init: function (data) {

        var mapCanvas = document.getElementById('objects-map');
        var mapOptions = {
            center: new google.maps.LatLng(data.center.lat, data.center.lng),
            zoom: data.center.zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false
        }

        var map = new google.maps.Map(mapCanvas, mapOptions);
        directionMap = map;

        this.addMakers(map, data.objects);
        this.bindDirectionButton();
    },

    addMakers: function (map, objects) {
        var markers = [];
        var infowindows = [];

        for (i = 0; i < objects.length; ++i) {

            var image = '/img/ico/map-marker-blue.png';
            var myLatLng = new google.maps.LatLng(objects[i].lat, objects[i].lng);

            markers[i] = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: image,
                iconTemp: false
            });

            //tooltip dla markera - dla wszytskich ustawiony jest ta sama przykladowa  tresc

            var contentString = '<div class="map-infowindow">' +
                '<a target="_blank" href="' + objects[i].link + '"><img src="' + objects[i].image_url + '" width="120" alt="' + objects[i].name + '"></a>' +
                '<div class="bodyContent">' +
                '<a target="_blank" href="' + objects[i].link + '" class="title">' + objects[i].name + '</a>' +
                '<p>Liczba miejsc na konferencje: <span>' + objects[i].biggest_hall_capacity + '</span></p>' +
                '<p>Liczba miejsc noclegowych: <span>' + objects[i].beds_amount + '</span></p>' +
                '<a target="_blank" href="' + objects[i].link + '" class="flat-button">ZOBACZ PREZENTACJĘ<i class="fa fa-chevron-right"></i></a>' +
                '</div>' +
                '</div>';

            var infowindow = new google.maps.InfoWindow();
            infowindows.push(infowindow);

            //przypina tooltip do markera
            this.bindInfoWindow(map, markers[i], infowindow, contentString, 'blue', markers, infowindows);
        }

    },

    bindDirectionButton: function () {

        var thisMap = this;

        $('#directionFrom').submit(function () {

            $('#mapDirectionAlert').text('');

            if ($('#directionAddress').val() == '') {
                $('#mapDirectionAlert').text('Pole jest wymagane.');
                return false;
            }

            if (!selectedLat) {
                $('#mapDirectionAlert').text('Zaznacz obiekt na mapie.');
                return false;
            }

            thisMap.showDirection();
            return false;
        });
    },

    showDirection: function () {
        var request = {
            origin: $('#directionAddress').val(),
            destination: selectedLat + "," + selectedLng,
            travelMode: google.maps.DirectionsTravelMode.DRIVING
        };
        directionsService.route(request, function (result, status) {
            if (status == google.maps.DirectionsStatus.OK) {
                if (trasa != null) trasa.setMap(null);
                polylineOptions = {
                    map: directionMap,
                    strokeColor: "#015296",
                    strokeOpacity: 0.9,
                    strokeWeight: 3,
                    path: result.routes[0].overview_path,
                }
                trasa = new google.maps.Polyline(polylineOptions);
                directionMap.fitBounds(result.routes[0].bounds);
                $('#mapDirectionAlert').text(result.routes[0].legs[0].distance.text + ' / ' + result.routes[0].legs[0].duration.text);
            } else {
                $('#mapDirectionAlert').text('Nie znaleziono adresu początkowego.');
                return false;
            }
        });
    },

    bindInfoWindow: function (map, marker, infowindow, contentString, markerico, allmarkers, allinfowindows) {

        google.maps.event.addListener(marker, 'mouseover', function () {
            infowindow.setContent(contentString);
            infowindow.open(map, marker);
            marker.setIcon('/img/ico/map-marker-dark_blue.png')
        });

        google.maps.event.addListener(marker, 'mouseout', function () {

            if (marker.iconTemp == false) {
                marker.setIcon('/img/ico/map-marker-' + markerico + '.png');
                infowindow.close();
            }
        });

        var thisMap = this;

        //maker click event - zapamietywanie stanu markera
        google.maps.event.addListener(marker, 'click', function () {

            if (marker.iconTemp == false) {

                for (i = 0; i < allinfowindows.length; ++i) {

                    allinfowindows[i].close();

                    if (allmarkers[i].iconTemp != false) {

                        allmarkers[i].setIcon('/img/ico/map-marker-' + allmarkers[i].iconTemp + '.png');
                    }

                    allmarkers[i].iconTemp = false;
                }

                infowindow.setContent(contentString);
                infowindow.open(map, marker);
                marker.setIcon('/img/ico/map-marker-dark_blue.png');
                marker.iconTemp = markerico;

                selectedLat = marker.getPosition().lat();
                selectedLng = marker.getPosition().lng();

                thisMap.showDirection();
            } else {

                marker.setIcon('/img/ico/map-marker-' + markerico + '.png');
                infowindow.close();
                marker.iconTemp = false;

            }
        });
    }
}

$(document).ready(function () {

    //======HOME
    app.home.searchBox.tabsInit();
    app.home.news.tabsInit();
    app.home.map.init();

    //=== STRONA OBIEKTU
    //mapka na stronie obiektu - lokalizacja
    if ($('#location-map').length) {
        app.object.locationMap.init();
    }

    app.object.commmentForm.init();
    app.object.slider.init();
    app.object.verticalCarousel.init();
    app.object.horizontalCarousel.init();
    app.object.video.init();


    //=========================POPUPY

    $('.question-form-popup').magnificPopup({
        type: 'ajax',
        midClick: true,
        callbacks: {
            ajaxContentAdded: function () {
                app.object.questionForm.init();
            }
        }
    });

    if ($('#overlay-popup').length) {
        $.magnificPopup.open({
            items: {
                src: '#overlay-popup'
            },
            type: 'inline',
            closeOnContentClick: false,
            closeOnBgClick: false,
            enableEscapeKey: false
        });
    }

    $('#queston-form-after').magnificPopup({
        type: 'inline',
        midClick: true
    });

    //=========INNE

    //karuzela stopka
    app.footer.Carouselinit();

    //selecty customowe

    $('.custom-select option[value="Wybierz"]').text('');
    $('.custom-select').SumoSelect({
        placeholder: 'Wybierz'
    });


    //scroll top icon
    $(".go-top-ico").click(function () {
        $("html, body").animate({scrollTop: 0}, "slow");
        return false;
    });


    //tooltip
    $('.tooltip').tooltipster({
        contentAsHTML: true,
        maxWidth: 900,
        theme: 'tooltipster-mk'
    });

    $('#recommend-slider').owlCarousel({

        items: 3,
        itemsDesktop: [1140, 3],
        itemsDesktopSmall: [979, 3],
        itemsTablet: [768, 2],
        itemsTabletSmall: [640, 2],
        itemsMobile: [550, 1],
        pagination: true,
        navigation: true,
        scrollPerPage: true,
        slideSpeed: 500

    });


    $('.partner-article').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    $('.objects-graphic-map,.info-box').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    $('.object-box').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    $('.article-item').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });
});

*/

$('#telshow').click(function() {
    $.ajax({
        'async': false,
        'url': '/show_tel/' + +$(this).data('id'),
        'type': 'post'
    }).done(function(data) {
        $('#telshow').parent().html(data);
    });
});

$('#emailshow').click(function() {
    $.ajax({
        'async': false,
        'url': '/show_email/' + +$(this).data('id'),
        'type': 'post'
    }).done(function(data) {
        $('#emailshow').parent().html(data);
    });
});


$('#telshow_2').click(function() {
    $.ajax({
        'async': false,
        'url': '/show_tel/' + +$(this).data('id'),
        'type': 'post'
    }).done(function(data) {
        $('#telshow_2').parent().html(data);
    });
});

$('#emailshow_2').click(function() {
    $.ajax({
        'async': false,
        'url': '/show_email/' + +$(this).data('id'),
        'type': 'post'
    }).done(function(data) {
        $('#emailshow_2').parent().html(data);
    });
});

$(window).load(function(){
    setTimeout(function() {
        $(".overlayouter").show();
        $("html").addClass("ov-hidden")
    }, 3000)
})